var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 12.125H2.125C1.79348 12.125 1.47554 11.9933 1.24112 11.7589C1.0067 11.5245 0.875 11.2065 0.875 10.875V2.125C0.875 1.79348 1.0067 1.47554 1.24112 1.24112C1.47554 1.0067 1.79348 0.875 2.125 0.875H10.875C11.5688 0.875 12.125 1.43125 12.125 2.125V10.875C12.125 11.2065 11.9933 11.5245 11.7589 11.7589C11.5245 11.9933 11.2065 12.125 10.875 12.125ZM9.36875 4.18125L6.5 7.05L3.63125 4.18125L2.75 5.06875L6.5 8.81875L10.25 5.06875L9.36875 4.18125Z",
    fill: "#FD3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenor);
export default __webpack_public_path__ + "static/media/menor.c8d2e88826bccb46764585e334a983ee.svg";
export { ForwardRef as ReactComponent };